import { AwaitContainer, Button, DialogRoot, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useExpertReportBlockRule } from '@/entities/expert-report';
import { useHasPermission } from '@/entities/profile';

type Props = {
  ruleId?: number;
  expertReportId: number;
  blockId: number;
  onClose: () => void;
};

export const RuleDetailDialog: FC<Props> = ({ ruleId, expertReportId, blockId, onClose }) => {
  const { t } = useTranslation(['dialogs']);
  const { data, isLoading } = useExpertReportBlockRule(ruleId);
  const canViewExpertReport = useHasPermission('VIEW_EXPERT_REPORT');
  return (
    <DialogRoot open={!!ruleId} onOpenChange={(open: boolean) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`${t('expertReport.ruleTitle')}: ${data?.name ?? ''}`}</DialogTitle>
        </DialogHeader>
        <AwaitContainer isLoading={isLoading}>
          <div className="whitespace-pre-wrap text-sm">{data?.text}</div>
        </AwaitContainer>
        <DialogFooter className="flex items-center">
          {canViewExpertReport && (
            <Link
              to={`/expert-report/${expertReportId}/block/${blockId}`}
              className="text-primary underline text-sm hover:text-primary/80"
            >
              {t('expertReport.openCard')}
            </Link>
          )}
          <Button variant="outline" onClick={onClose}>
            {t('expertReport.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
